/* eslint-disable-next-line  no-unused-vars */
import { createElement, useEffect } from 'react';
import { createContext, useState } from 'react';
export const ActionContext = createContext();

export default function ActionContextProvider({ action, setAction, children }) {
    const [selectedAction, setSelectedAction] = useState('');

    useEffect(() => {
        setSelectedAction(action);
    }, [action]);

    return (
        <ActionContext.Provider
            value={{
                selectedAction,
                setAction
            }}
        >
            {children !== null ? children : <></>}
        </ActionContext.Provider>
    );
}
